import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ConfigService} from '../../../../core/services';
import {UntypedFormGroup} from '@angular/forms';
import {AdminSearchFilterModel} from '../../../../api/model/Admin-user.model';

@Component({
  selector: 'tj-admin-search-labels',
  templateUrl: './admin-search-labels.component.html',
  styleUrls: ['./admin-search-labels.component.scss'],
})
export class AdminSearchLabelsComponent {
  @Input() adminFilter: AdminSearchFilterModel;
  @Input() filterForm: UntypedFormGroup;
  @Output() remove = new EventEmitter();

  filterNames = {
    id: 'Id',
    firstName: 'Name',
    lastName: 'Surname',
    username: 'Username',
    email: 'Email',
  };

  constructor(public config: ConfigService) {
  }

  onRemoveFilter(filterName: string) {
    const updatedFilter = {...this.adminFilter};
    if (updatedFilter[filterName]) {
      updatedFilter[filterName] = null;
      if (this.filterForm && this.filterForm.get(`${filterName}`)) {
        this.filterForm.get(`${filterName}`).setValue(null);
      }
    }
    this.remove.emit(updatedFilter);
  }

}
